import {Event} from 'main.core';

export class SkuProperty extends Event.EventEmitter {
    constructor(params = {}) {
        super();
        this.setEventNamespace('BX.Asteq.Catalog.SkuProperty');

        this.attrs = {
            propsList: 'data-props-list',
            propValue: 'data-prop-value',
            propDisplaySelectedValue: 'data-display-selected-prop-value',
        };

        this.manager = params.manager;
        this.data = params.data;
        this.selectedId = params.selectedId || 0;

        this.valuesListEl = null;
        this.valuesEls = null;
        this.displayValueEl = null;

        this.initElements();
        this.initEvents();
    }

    getBlockElement() {
        return this.manager?.el || document;
    }

    getId() {
        return this.data?.id;
    }

    getSelectedId() {
        return this.data?.selectedId;
    }

    setDisplayValues(valuesIds) {
        const valuesEls = this.getValuesEls();
        if (!valuesEls || !valuesEls.length) {
            return;
        }

        valuesEls.forEach((el) => {
            const id = el.getAttribute(this.attrs.propValue);
            if (valuesIds.includes(parseInt(id, 10))) {
                el.style.display = '';
            } else {
                el.style.display = 'none';
            }
        });
    }

    initElements() {
        const blockElement = this.getBlockElement();
        if (!blockElement) {
            return;
        }

        this.valuesListEl = blockElement.querySelector(`[${this.attrs.propsList}="${this.getId()}"]`);

        if (this.valuesListEl) {
            this.valuesEls = this.valuesListEl.querySelectorAll('[' + this.attrs.propValue + ']');
        }

        this.displayValueEl = blockElement.querySelector(`[${this.attrs.propDisplaySelectedValue}="${this.getId()}"]`);
    }

    initEvents() {
        const blockElement = this.getBlockElement();
        if (!blockElement) {
            return;
        }

        if (this.valuesEls) {
            this.valuesEls.forEach((el) => {
                const id = el.getAttribute(this.attrs.propValue);
                el.addEventListener('click', this.onValueChange.bind(this, id));
            });
        }
    }

    getValuesEls() {
        return this.valuesEls;
    }

    selectValueById(id) {
        const valuesEls = this.getValuesEls();
        if (!valuesEls || !valuesEls.length) {
            return;
        }

        this.data.selectedId = id;
        const toggleClass = 'switch__item--active';

        valuesEls.forEach((el) => {
            const valueId = el.getAttribute(this.attrs.propValue);
            if (valueId == id) {
                el.classList.add(toggleClass);
            } else {
                el.classList.remove(toggleClass);
            }
        });

        if (this.displayValueEl) {
            this.displayValueEl.innerHTML = this.data.values[id].name;
        }
    }

    onValueChange(selectedId, e) {
        if (this.data.selectedId == selectedId) {
            return;
        }

        const oldId = this.getSelectedId();
        this.selectValueById(selectedId);

        this.emit('change', {
            selectedId: selectedId,
            oldId: oldId,
        });
    }
}